import { Injectable, Optional } from '@angular/core';
import { Subject, ReplaySubject } from 'rxjs';
import { ConfigurationService } from '../configuration/configuration.service';
import { IAppConfiguration } from '../configuration/i-configuration';
import { LogEntry } from './models/log-entry.model';
import { LogEventType } from './models/log-event-type.enum';
import { LogSourceLevel } from './models/log-source-level.enum';
import { Severity } from './models/severity.enum';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  serviceName = 'LoggingService';
  source: string;
  severity: Severity;
  message: string;
  timestamp: Date;
  applicationName: string = 'application';
  version: string = '0.0.0';
  loggingConfig: IAppConfiguration;

  logEntries$: Subject<LogEntry> = new ReplaySubject<LogEntry>(1);

  /**
   * The [LoggingService] constructor.
   */
  constructor(
    @Optional() public configService: ConfigurationService
  ) {
    this.timestamp = new Date(Date.now());
    this.log("Logging Service", LogEventType.Information, LogSourceLevel.Start, Severity.Info, `Starting logging service at: ${this.timestamp}`, "clientRefCode")
    if (configService) {
      this.loggingConfig = this.configService.applicationConfiguration;
      this.setupConfiguration();
    }
  }

  setupConfiguration() {
    if (this.configService && this.configService.applicationConfiguration) {

      this.applicationName = (this.loggingConfig && this.loggingConfig.env.appName) ? this.loggingConfig.env.appName : 'dummy application';
      this.version = (this.loggingConfig && this.loggingConfig.env.appVersion) ? this.loggingConfig.env.appVersion : '0.0.0';
      this.severity = (this.loggingConfig && this.loggingConfig.logging.severity) ? this.loggingConfig.logging.severity : Severity.Info;

    }
  }

  /**
   * Use this method to send a log message with severity and source information
   * to the application's logger.
   *
   * If the application environment mode is [Production], the information will
   * be sent to a centralized repository.
   *
   */
  log(moduleName: string, logEventType: LogEventType, source: LogSourceLevel, severity: Severity, message: string, clientRefCode: string, tags?: string[] | null) {

    this.loggingConfig = this.configService.applicationConfiguration;
    this.setupConfiguration();
    const logEntry = new LogEntry(this.applicationName, this.version, moduleName, logEventType, source, severity, message, clientRefCode, tags)
    let tmpLevel = this.severity - severity;
    this.logEntries$.next(logEntry);
    if (tmpLevel >= 0) {
      // this.logEntries$.next(logEntry);
    }
  }
}
